export const util = {
    getCookie(key: string) {
        const encodedName = encodeURIComponent(key).replace(
            /[\-\.\+\*]/g,
            "\\$&"
        );
        const regex = new RegExp(
            "(?:(?:^|.*;)\\s*" + encodedName + "\\s*\\=\\s*([^;]*).*$)|^.*$"
        );

        return decodeURIComponent(document.cookie.replace(regex, "$1")) || null;
    }
};

export const fontFamily =
    "Charlie Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif";
